<div class="image-modal">

    <img [src]="img" alt="imagen" >


  <p *ngIf="!img">No se pudo cargar la imagen.</p>
</div>
